import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_DM_CONSTITUENCY_CONFIG = defineFcm('petition_page_dm_constituency_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				readEnabled: { type: 'boolean', optional: true },
				enabled: { type: 'boolean' },
				relevantNormalizedPositionNames: {
					type: 'array',
					optional: true,
					shape: {
						type: 'string',
					},
				},
				constituents: {
					type: 'array',
					optional: true,
					shape: {
						type: 'object',
						shape: {
							petitionId: { type: 'string' },
							decisionMakerId: { type: 'string' },
							constituentCountAmongSigners: { type: 'number' },
						},
					},
				},
			},
		}),
	)
	.withDefault({
		readEnabled: false,
		enabled: false,
		constituents: [],
		relevantNormalizedPositionNames: [
			'City Legislature',
			'County Legislature//Executive Board',
			'Township Trustee//Township Council',
			'State Representative',
			'State Senator',
			'U.S. Representative',
			'City Executive//Mayor',
			'Township Supervisor',
			'Township Mayor',
		],
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: ['corgi-middle-end', 'signature-service'],
		context: 'New petition page DM card',
		description: 'Provides number of signers part of decision maker constituents',
		import: false,
		template: {
			readEnabled: false,
			enabled: false,
			constituents: [],
			relevantNormalizedPositionNames: [
				'City Legislature',
				'County Legislature//Executive Board',
				'Township Trustee//Township Council',
				'State Representative',
				'State Senator',
				'U.S. Representative',
				'City Executive//Mayor',
				'Township Supervisor',
				'Township Mayor',
			],
		},
	});
